import { Route, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { LegalPagesComponent } from './legal-pages.component';
import { LegalPrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { LegalImprintComponent } from './imprint/imprint.component';
import { LegalCookiesUsageComponent } from './cookies-usage/cookies-usage.component';
import { LegalTermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { LegalAffiliateTermsComponent } from './affiliate-terms/affiliate-terms.component';
import { LegalCancellationPolicyComponent } from './cancellation-policy/cancellation-policy.component';
import { LEGAL_PAGES_ROUTE_GUARD } from './legal-pages-route.guard';
import { LegalPagesRouteService } from './legal-pages-route.service';


export const LEGAL_ROUTES: Route[] = [
	{
		path		: 'legal',
		component	: LegalPagesComponent,
		children	: [
			{
				path		: 'privacy-policy',
				canActivate : [LEGAL_PAGES_ROUTE_GUARD],
				component	: LegalPrivacyPolicyComponent
			},
			{
				path		: 'cancellation-policy',
				canActivate : [LEGAL_PAGES_ROUTE_GUARD],
				component	: LegalCancellationPolicyComponent
			},
			{
				path		: 'cookies-usage',
				canActivate : [LEGAL_PAGES_ROUTE_GUARD],
				component	: LegalCookiesUsageComponent
			},
			{
				path		: 'terms-of-use',
				canActivate : [LEGAL_PAGES_ROUTE_GUARD],
				component	: LegalTermsOfUseComponent
			},
			{
				path		: 'affiliate-terms',
				canActivate : [LEGAL_PAGES_ROUTE_GUARD],
				component	: LegalAffiliateTermsComponent
			},
			{
				path		: 'imprint',
				canActivate : [LEGAL_PAGES_ROUTE_GUARD],
				component	: LegalImprintComponent
			},
			{
				path		: '',
				pathMatch	: 'full',
				redirectTo	: 'cookies-usage'
			}
		]
	}

];


@NgModule({
	imports: [RouterModule.forChild(LEGAL_ROUTES)],
	exports: [RouterModule],
	providers: [LegalPagesRouteService]
})
export class LegalRoutingModule {}
